const TopUpDataAnnatelURL = (topUp, number, Data) => {
  if (Data.category.toLowerCase().includes("prepaye")) {
    topUp = 'prepaid'
  }
  const url = window.location.href;
  const queryStringNumber = number ?  "product.php?number=" + number : '';
  const websiteURL =  url.includes('en_US') ? "https://www.annatel.us/" + topUp + "/en/" : "https://www.annatel.co.il/"+ topUp + "/fr/";

  return websiteURL + queryStringNumber;
}
export default TopUpDataAnnatelURL;



// WEBPACK FOOTER //
// ./src/localeAssets/TopUpDataAnnatelURL.js